export const ALL_AUTOCOMPLETE_URL = "/research/japi/pub/search/category/queryAll/";
export const ALL_THEMES = "All Themes";
export const EVENT_THEME = "eventTheme";
export const THEME_SUBTHEME = "theme_subtheme";
export const INITIAL_THEMES_FILTER = "initialThemesFilter";